import { selectCategory } from "@/store/slices/category";
import { toTitleCase } from "@/utils/text-methods";
import Link from "next/link";
import React from "react";
import { useSelector } from "react-redux";

const CatgeoryBreadcrumb = () => {
  const categoryState = useSelector(selectCategory);

  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        <li className="breadcrumb-item">
          <Link href="/">Home</Link>
        </li>
        {categoryState.mapping.map((item) => (
          <li className="breadcrumb-item" key={item.slug}>
            <Link href={`/jewellery/category/${item.slug}`}>
              <a>{toTitleCase(item.name)}</a>
            </Link>
          </li>
        ))}
        <li className="breadcrumb-item active ms-2">
          {toTitleCase(categoryState.data?.name || "")}
        </li>
      </ol>
    </nav>
  );
};

export default CatgeoryBreadcrumb;
